import { DocumentState } from "../enum/documentState.enum";
import { DocumentSubState } from "../enum/documentSubState.enum";
import { SortingCriteria } from "../enum/sortingCriteria.enum";
import { RuleBuilderConfig } from "app/infrastructure/services/ruleBuilder.service";
import { ComparisonOperator } from "../enum/comparisonOperator.enum";
import { StandardDictionary } from "app/infrastructure/model/interfaces/standarddictionary.interface";
import {OrganizationCategory} from 'app/infrastructure/model/interfaces/organizationCategory.interface'
import {EntitySubscription} from 'app/infrastructure/model/interfaces/entitySubscription.interface'
import { MappedAttribute } from "app/helpers/components/mappingAttribute/mappingAttribute.component";

export interface ReportConfiguration {
    id:string;
    reportCode: string;
    systemCode: string;
    businessCode: string;
    name: string;
    breadcrumb?: string;
    documentState?: DocumentState;
    documentStateCriteria?: ComparisonOperator;
    documentStateValue?: string;
    documentSubState?: DocumentSubState;
    documentSubStateCriteria?: ComparisonOperator;
    documentSubStateValue?: string;
    orderBy?: string;
    orderByCriteria?: SortingCriteria;
    status: string;
    isExternal: boolean;
    creado?: string;
    modificado?: string;
    fechaCreacion?: Date;
    fechaActualizacion?: Date;
    reportRuleSet: RuleBuilderConfig;
    // the real column dto is never touched
    targetProducts?: string[];
    columns?: string[];
    category: OrganizationCategory;
    subscriptions: EntitySubscription[];
    standardDictionary: StandardDictionary;
}

export interface ReportConfigurationColumn extends MappedAttribute {
    systemCode: string;
    businessCode: string;
    reportCode: string;
    columnType: string;
    description: string;
    reportConfigurationId: string;
}

export interface ReportConfigurationProduct {
    systemCode: string;
    businessCode: string;
    productCode: string;
    description: string;
    attributes: string[];
}

export interface AttributeCounter{
    count : number;
    attribute : string;
}

export const BannedSortables: string[] = [
    'FlowState',
    'SaleQuotas',
    'SaleCommissions',
    'PaymentSuccessful',
    'PaymentFailedAttempts',
    'PaymentReferenceNumber',
    'PaymentAmount',
    'PaymenDate',
    'PaymentUser',
    'PaymentExtraInfo',
    'QuoteResultPlans'
];



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/interfaces/reportConfiguration.interface.ts